import providers from "@/lib/api";
import config from "@/config";

export const userPublicDataFieldsWithStoryInfo = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("UserPublicData");
  if (config.featureStories) r += "... on UserPublicData { hasStories firstNotViewedStoryId }";
  return r;
};

export const messageThreadFields = (): string => {
  let r = providers.UserPublicDataProvider.getFragment("MessageThread");
  if (config.featureStories)
    r += "... on MessageThread { users {... on UserPublicData { hasStories firstNotViewedStoryId }}}";
  return r;
};

export const feedFields = (): string => {
  return config.featureFeedPublicReview
    ? providers.ContentFeedProvider.getFragment("ContentFeed") +
        `... on ContentFeed { reviews { ${providers.ContentFeedProvider.getPageableFragment("Review")}}}`
    : "";
};

export const userWithAvatarFields = (data: { onlineStatus: boolean }): string => {
  return (
    providers.UserPublicDataProvider.getFragment("UserWithAvatar") +
    "... on UserPublicData { role " +
    (data.onlineStatus ? `onlineStatus { ${providers.OnlineStatusProvider.getFragment("OnlineStatus")} }` : "") +
    "}"
  );
};

// a card of the home page shows only a part of a post, so the rest of its fields is not requested
export const homeFeedFields = (data: { distance: boolean; subscription: boolean }): string => {
  const userFields = providers.UserPublicDataProvider.getFragment("UserPublicData");
  const viewerRelatedFields = [
    data.distance && `distance { ${providers.UserPublicDataProvider.getFragment("UserDistance")} }`,
    data.subscription && "subscriptionFromMe { id }",
  ].filter(Boolean);

  return `
    ... on HomeFeedItem {
      userId
      setId
      user {
        ${userFields}
        ${viewerRelatedFields.length ? `... on UserPublicData { ${viewerRelatedFields.join(" ")} }` : ""}
      }
      contentFeed {
        ... on ContentFeed {
          id
          description
          files { ${providers.ContentFilesProvider.getFragment("ContentFile")} }
          participants {
            ... on Participant {
              id
              user { ${userFields} }
            }
          }
        }
      }
    }
  `;
};
